import styled from 'styled-components'

import starIcon from '../../styles/assets/atp/star.svg'
import Icon from '../icon/Icon'
import { Text } from '../topography'
import { fonts, palette } from '../../styles/variables'
import { translate } from '../../utils/translation'

const defaultStyles = {
  position: 'absolute',
  right: '50px',
  bottom: '-20px',
  zIndex: 1,
}

const LimitedOfferStyled = styled.div(({ styles }) => ({
  ...styles,
}))

export const LimitedOffer = ({ styles = defaultStyles }) => {
  return (
    <LimitedOfferStyled styles={{ ...styles }}>
      <Icon className="rotating" src={starIcon} size={58} />
      <Text
        fontSize="10px"
        textAlign="center"
        fontFamily={fonts.primaryMedium}
        color={palette.white}
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%) rotate(-15deg)',
          wordBreak: 'normal',
        }}
      >
        {translate('limited_offer')}
      </Text>
    </LimitedOfferStyled>
  )
}
